import { createRouter, createWebHistory } from "vue-router";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "@/services/firebase";
import { useAuthStore } from "@/stores/auth";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      name: "dashboard",
      component: () => import("@/views/DashboardView.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/login",
      name: "login",
      component: () => import("@/views/LoginView.vue"),
      meta: { guestOnly: true },
    },
    { path: "/:pathMatch(.*)*", redirect: "/" },
  ],
});

let authReady: Promise<void> | null = null;

function whenAuthReady(): Promise<void> {
  if (authReady) return authReady;
  authReady = new Promise<void>((resolve) => {
    const unsub = onAuthStateChanged(auth, () => {
      unsub();
      resolve();
    });
  });
  return authReady;
}

router.beforeEach(async (to) => {
  await whenAuthReady();
  const store = useAuthStore();
  store.init();

  if (to.meta.requiresAuth && !store.user) {
    return { name: "login", query: { redirect: to.fullPath } };
  }
  if (to.meta.guestOnly && store.user) {
    return { name: "dashboard" };
  }
  return true;
});

export default router;
